import { AdviceStepComponent } from './../form-steps/advice-step/advice-step.component';
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { DateSettedComponent } from "../form-steps/date-setted/date-setted.component";
import { FormSummary } from "../form-steps/form-summary/form-summary";
import { MeetingCompletedComponent } from "../form-steps/meeting-completed/meeting-completed.component";
const routes = [

    {
      path: '',
      redirectTo: 'summary',
      pathMatch: 'full'
    },
  
    {
        path: 'first',
        component: AdviceStepComponent, // to define
        /*children: [{
          path: '',
          loadChildren:
            () => import('./form/meeting-form/meeting-form.module')
            .then(m => m.MeetingFormModule),
          outlet: 'formstep'
        }]*/
    },
    {
        path: 'summary',
        component: FormSummary,
        data: {form: 'composer', survey_kind: 'advice'}
    }
    
  ]
  
  @NgModule({
    imports: [
      RouterModule.forChild(routes),
    ],
    exports: [
      RouterModule
    ]
  })
  export class FourthMeetingRoutingModule {
  
  }